// extracted by mini-css-extract-plugin
export default {"form":"form-module--form--1v7CZ"};